import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';

import {GeneralComponent} from "./general/general.component";

import {BsDatepickerModule, defineLocale} from 'ngx-bootstrap';
import {esLocale} from 'ngx-bootstrap/locale';
import {DashboardModule} from "./dashboard/dashboard.module";
import {MaterialModule} from "../../../material.module";
import {LoadingModule} from "../../../autenticacion/loadingScreen/loading.module";
import {RegistroVentaComponent} from "./registroVenta/registroVenta.component";

defineLocale('es', esLocale);

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        BsDatepickerModule.forRoot(),
        DashboardModule,
        MaterialModule,
        LoadingModule,
        ReactiveFormsModule
    ],
    declarations: [GeneralComponent, RegistroVentaComponent]
})
export class ReporteModule {
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/reporte/reporte.module.ts